import Alpine from "alpinejs";

export const uiFontSize = {
  init() {
    this._setBaseFontSize();
  },

  _setBaseFontSize() {
    Alpine.effect(() => {
      let baseFontSize = Alpine.store('userPreferences').fontSize;
      console.log("Setting Base Font Size to " + baseFontSize);
      document.body.style.setProperty(
        "--bs-body-font-size",
        baseFontSize + "px",
      );
      document.documentElement.style.fontSize = baseFontSize + "px";
    });
  },
};
